module.exports = __webpack_public_path__ + "images/help/icon-twr40-be027e9f0d632aada4e6557c5c5889e3.png";